export default __webpack_public_path__ + "static/media/CaesarWrap.1d13f709.jpg";